'use client';

import { Content } from '@prismicio/client';
import type { Simplify } from '../../../../../prismicio-types';
import { Button, Container } from '@/components';

import styles from './loanUsesHero.module.scss';
import { HeroList, Subtitle, Title } from '../../components';
import { useVisible } from '@/hooks';
import { LoanUsesHeroCards } from './LoanUsesHeroCards/LoanUsesHeroCards';

interface LoanUsesHeroProps {
  data: Simplify<Content.HeroSliceLoanUsesPrimary>;
}

export const LoanUsesHero = ({ data }: LoanUsesHeroProps) => {
  const [isVisible, id] = useVisible();
  return (
    <Container styles={styles.container} id={id}>
      <article className={styles.text_wrapper}>
        <Title text={data.title} isVisible={isVisible} />
        <Subtitle
          subtitle={data.subtitle}
          isVisible={isVisible}
          styles={styles.subtitle}
        />
        <HeroList list={data.advantages} isVisible={isVisible} />
        <div
          className={`${styles.button_wrapper} ${isVisible ? styles.isVisible : ''}`}
        >
          <Button
            text={data.button_text}
            link={data.button_link}
            isArrow
            variation="primary"
          />
        </div>
      </article>
      <LoanUsesHeroCards data={data} />
    </Container>
  );
};
